import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=227b3c2e&"
import script from "./ToolbarItem.vue?vue&type=script&lang=js&"
export * from "./ToolbarItem.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wolf/Documents/Apps/Trading/trading-vue-bundle/trading-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227b3c2e')) {
      api.createRecord('227b3c2e', component.options)
    } else {
      api.reload('227b3c2e', component.options)
    }
    module.hot.accept("./ToolbarItem.vue?vue&type=template&id=227b3c2e&", function () {
      api.rerender('227b3c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToolbarItem.vue"
export default component.exports